import React from 'react';
import { Mail, Clock, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const Contact = () => {
  return (
    <div className="page-contact">
      {/* Hero */}
      <section className="contact-hero section-padding">
        <div className="container">
          <div className="section-header">
            <h1 className="hero-large">Get in Touch</h1>
            <p className="body-large">
              Have questions about our services, pricing, or whether Glow Health is right for you? We're here to help.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="section-padding-small">
        <div className="container">
          <div className="contact-simple-grid">
            <div className="contact-info-card">
              <Phone className="contact-icon-large" />
              <h3 className="heading-3">Call Us</h3>
              <p className="body-regular">
                <a href="tel:385-396-5565" className="contact-phone-link">385-396-5565</a>
              </p>
              <p className="body-small">Mon-Fri: 9am - 6pm EST</p>
            </div>

            <div className="contact-info-card">
              <Mail className="contact-icon-large" />
              <h3 className="heading-3">Email Us</h3>
              <p className="body-regular">support@myglowhealth.co</p>
              <p className="body-small">We respond within 1 business day</p>
            </div>

            <div className="contact-info-card">
              <Clock className="contact-icon-large" />
              <h3 className="heading-3">Office Hours</h3>
              <p className="body-regular">Monday - Friday: 9am - 6pm EST</p>
              <p className="body-small">Weekend appointments available</p>
            </div>

            <div className="contact-info-card">
              <MapPin className="contact-icon-large" />
              <h3 className="heading-3">Availability</h3>
              <p className="body-regular">Virtual consultations nationwide</p>
              <p className="body-small">Accessible from anywhere in the US</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section-padding bg-secondary">
        <div className="container">
          <h2 className="heading-1" style={{textAlign: 'center', marginBottom: '60px'}}>Common Questions</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3 className="heading-3">How do I get started?</h3>
              <p className="body-regular">
                Complete our intake form and we'll review your information. A team member will reach out within 1 business day to schedule your initial consultation.
              </p>
              <Link to="/intake">
                <button className="btn-secondary" style={{marginTop: '16px'}}>Start Intake Form</button>
              </Link>
            </div>
            <div className="faq-item">
              <h3 className="heading-3">Do you accept insurance?</h3>
              <p className="body-regular">
                We are currently out-of-network with most insurance providers. We can provide superbills for potential reimbursement. Many FSA/HSA cards are accepted.
              </p>
            </div>
            <div className="faq-item">
              <h3 className="heading-3">What states do you serve?</h3>
              <p className="body-regular">
                We provide virtual consultations to patients nationwide. Our clinicians are licensed to practice telehealth across all 50 states.
              </p>
            </div>
            <div className="faq-item">
              <h3 className="heading-3">How long is the initial consultation?</h3>
              <p className="body-regular">
                Your first appointment is a comprehensive 60-minute virtual visit where we'll discuss your health history, symptoms, and goals in detail.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-banner">
        <div className="container">
          <div className="cta-content">
            <h2 className="hero-medium">Ready to start?</h2>
            <p className="body-large">Begin your intake form and we'll be in touch soon.</p>
            <Link to="/intake">
              <button className="btn-primary">Complete Intake Form</button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;